export default __webpack_public_path__ + "static/media/advantagerecuperation.a3e7b040.png";